import styled from 'styled-components';
import {GlobalColors, GlobalFonts} from '../globals';

//const hiddenStyle = css`
//  display: none;
//`;

export const ContCardIdentity = styled.div`
  width: 90%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;

  @media(min-width: 100px) and (max-width: 600px){
    width: 95% !important;
    margin: 20px auto;
  }
`

export const IdentityCont = styled.div`
  width: 100%;
  height: 500px;
  border-radius: 20px;
  background: linear-gradient(135deg, #0B6BDD, #0C3A72);

  @media(min-width: 300px) and (max-width: 767px){
    height: 700px;
  }
  @media(min-width: 768px) and (max-width: 899px){
    height: 700px;
  }
`

export const ContTextIdentity = styled.h1`
  margin-bottom: 20px;
  font-family: ${GlobalFonts.fontBold};
  text-align: left;
  color: ${GlobalColors.colorSecondary};
  
  @media(min-width: 300px) and (max-width: 767px){
    font-size: 30px;
    line-height: 38px;
    text-align: left;
  }
  @media(min-width: 768px) and (max-width: 1023px){
    position: relative;
    width: 100%;
    margin: 0 auto 35px;
    font-size: 36px;
    line-height: 40px;
    text-align: left;
  }
  @media(min-width: 1024px) and (max-width: 1079px){
    font-size: 36px;
    line-height: 36px;
  }
  @media(min-width: 1080px) and (max-width: 1279px){
    font-size: 34px;
    line-height: 46px;
    
  }
  @media(min-width: 1280px) and (max-width: 1407px){
    font-size: 46px;
    line-height: 46px;
  }
  @media(min-width: 1408px) and (max-width: 1439px){
    font-size: 46px;
    line-height: 56px;
  }
  @media(min-width: 1440px) and (max-width: 1919px){
    font-size: 46px;
    line-height: 56px;
  }
  @media(min-width: 1920px){
    font-size: 46px;
    line-height: 46px;
  }
`

export const TextIdentitySummary = styled.div`
  margin-bottom: 40px;
  font-family: ${GlobalFonts.fontRegular};
  font-size: 16px;
  line-height: 22px;
  color: ${GlobalColors.colorSecondary};
  
  & > span {
    font-family: ${GlobalFonts.fontBold};
  }

  @media(min-width: 300px) and (max-width: 767px){
    margin-bottom: 40px;
    font-size: 16px;
    line-height: 22px;
    text-align: left;
  }
  @media(min-width: 768px) and (max-width: 1023px){
    position: relative;
    width: 100%;
    margin: 0 auto 35px;
    font-size: 16px;
    line-height: 22px;
    text-align: left;
  }
  @media(min-width: 1024px) and (max-width: 1079px){
    font-size: 14px;
    line-height: 24px;
  }
  @media(min-width: 1080px) and (max-width: 1144px){
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 40px;
  }
  @media(min-width: 1145px) and (max-width: 1249px){
    font-size: 15px;
    line-height: 24px;
    margin-bottom: 40px;
  }
  @media(min-width: 1250px) and (max-width: 1279px){
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 40px;
  }
  @media(min-width: 1280px) and (max-width: 1407px){
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 40px;
  }
  @media(min-width: 1408px) and (max-width: 1439px){
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 40px;
  }
  @media(min-width: 1440px) and (max-width: 1919px){
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 40px;
  } 
`
export const ContOnb = styled.div`
  margin-bottom: 10px;
`

export const ContHowWork = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 90px;

  @media(min-width: 200px) and (max-width: 299px){
    padding-top: 10px !important;
  }
  @media(min-width: 300px) and (max-width: 499px){
    padding-top: 10px !important;
  }
  @media(min-width: 500px) and (max-width: 599px){
    padding-top: 50px !important;
  }
  @media(min-width: 600px) and (max-width: 767px){
    padding-top: 50px !important;
  }
  @media(min-width: 768px) and (max-width: 1023px){
    padding-top: 120px !important;
  }
  @media(min-width: 1024px) and (max-width: 1079px){
    padding-top: 80px !important;
  }
  @media(min-width: 1080px) and (max-width: 1279px){
    padding-top: 80px !important;
  }
  @media(min-width: 1280px) and (max-width: 1407px){
    padding-top: 80px !important;
  }
  @media(min-width: 1408px) and (max-width: 1439px){
    padding-top: 90px !important;
  }
  @media(min-width: 1440px) and (max-width: 1919px){
    padding-top: 90px !important;
  }
  @media(min-width: 1440px) and (max-width: 1639px){
    padding-top: 90px !important;
  }
  @media(min-width: 1640px) and (max-width: 1919px){
    padding-top: 90px !important;
  }
  @media(min-width: 1920px){
    padding-top: 100px !important;
  }
`;

export const TitleHowWork = styled.h2`
  margin-bottom: 20px;
  font-family: ${GlobalFonts.fontBold};
  font-size: 64px;
  line-height: 74px;
  color: ${GlobalColors.colorPrimaryDark};

  @media(min-width: 200px) and (max-width: 299px){
    margin-top: 50px;
  }
  @media(min-width: 300px) and (max-width: 399px){
    margin-top: 50px;
  }
  @media(min-width: 400px) and (max-width: 497px){
    margin-top: 50px;
  }
  @media(min-width: 498px) and (max-width: 500px){
    margin-top: 20px;
  }
  
  @media(min-width: 300px) and (max-width: 767px){
    font-size: 30px;
    line-height: 38px;
    text-align: left;
  }
  @media(min-width: 768px) and (max-width: 1023px){
    font-size: 40px;
    line-height: 50px;
  }
  @media(min-width: 1024px) and (max-width: 1079px){
    font-size: 36px;
    line-height: 36px;
  }
  @media(min-width: 1080px) and (max-width: 1279px){
    font-size: 34px;
    line-height: 46px;
  }
  @media(min-width: 1280px) and (max-width: 1407px){
    font-size: 46px;
  }
  @media(min-width: 1408px) and (max-width: 1439px){
    font-size: 46px;
  }
  @media(min-width: 1440px) and (max-width: 1919px){
    font-size: 46px;
  }
  @media(min-width: 1920px){
    font-size: 46px;
  }
`;
export const ContTextDescHowWork = styled.div`
  width: 75%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`
export const TextDescHowWork = styled.div`
  margin-bottom: 40px;
  font-family: ${GlobalFonts.fontRegular};
  font-size: 20px;
  line-height: 28px;
  color: ${GlobalColors.colorText};
`;

